/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import i18n from 'i18next';

import { registerField } from 'core/forms';
import { addToast } from 'core/notifications';

import defaultFileUploader from '../../files/helpers/fileUploader';
import getFilePreview from '../../files/helpers/getFilePreview';

import FormFieldUpload from '../components/formFieldUpload';

const FormFieldUploadContainer = createReactClass({
  propTypes: {
    hasIcon: PropTypes.bool,
    icon: PropTypes.string,
    iconPosition: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.shape({
        alt_text: PropTypes.string,
        name: PropTypes.string,
        type: PropTypes.string,
        url: PropTypes.string,
      }),
      PropTypes.string,
    ]),
    schema: PropTypes.shape({
      buttonSize: PropTypes.string,
      className: PropTypes.string,
      maxUploadSize: PropTypes.number.isRequired,
      uploadType: PropTypes.string,
      uploadButtonText: PropTypes.string.isRequired,
      hasReplaceUploadButton: PropTypes.bool.isRequired,
      replaceUploadButtonText: PropTypes.string.isRequired,
      hasRemoveUploadButton: PropTypes.bool,
      removeUploadButtonText: PropTypes.string,
      permittedFormats: PropTypes.string,
      documentsUrlPrefix: PropTypes.string,
      policyUrlPrefix: PropTypes.string,
      fileUploader: PropTypes.func,
      isDisabled: PropTypes.bool,
      hasAltTextInput: PropTypes.bool,
    }),
    updateField: PropTypes.func.isRequired,
    fieldId: PropTypes.string.isRequired,
  },

  getDefaultProps() {
    return {
      hasIcon: false,
      icon: '',
      iconPosition: 'right',
      value: {
        url: null,
      },
      schema: {
        buttonSize: 'medium',
        hasRemoveUploadButton: false,
        removeUploadButtonText: '',
        documentsUrlPrefix: '',
        policyUrlPrefix: '',
        fileUploader: defaultFileUploader,
        isDisabled: false,
        hasAltTextInput: false,
      },
    };
  },

  getInitialState() {
    const { value } = this.props;

    let url = null;
    let type = null;
    let name = null;
    let alt_text = null;
    let id = null;

    if (typeof value === 'object' && value !== null) {
      url = value.url;
      type = value.type;
      name = value.name;
      alt_text = value.alt_text;
      id = value.id;
    }
    if (typeof value === 'string') url = value;

    return {
      upload: {
        id,
        url,
        type,
        name,
        alt_text,
        file: null,
        status: null,
        progress: 0,
        error: null,
      },
    };
  },

  componentWillUnmount() {
    URL.revokeObjectURL(this.state.upload.url);
  },

  handleRemoveUpload() {
    this.setState({
      upload: {
        url: null,
        file: null,
        status: null,
        progress: 0,
        name: null,
        alt_text: null,
      },
    });
    this.props.updateField(null);
  },

  handleFileUpload(file) {
    const {
      maxUploadSize,
      documentsUrlPrefix,
      policyUrlPrefix,
      fileUploader = defaultFileUploader,
    } = this.props.schema;

    if (file.size > maxUploadSize * 1000000) {
      this.setState({
        upload: {
          status: 'error',
          error: i18n.t('max-file-size', { maxFileSize: maxUploadSize }),
          progress: 0,
        },
      });
      addToast(i18n.t('max-file-size', { maxFileSize: maxUploadSize }), 'error');
      return;
    }

    const filePreview = getFilePreview(file);

    fileUploader(
      file,
      {
        start: () => {
          this.setState({
            upload: {
              error: null,
              status: 'uploading',
              progress: 0,
              url: filePreview,
            },
          });
        },
        progress: (percent) => {
          if (percent !== 100) {
            this.setState({
              upload: {
                file,
                status: 'uploading',
                progress: percent,
                url: filePreview,
              },
            });
          }
        },
        complete: (completionObj) => {
          this.setState((prevState) => ({
            upload: {
              ...prevState.upload,
              status: 'complete',
              progress: 100,
              file,
              url: completionObj.url || completionObj,
            },
          }));
          this.props.updateField(
            this.props.schema.hasAltTextInput
              ? {
                  ...(completionObj.url ? completionObj : { url: completionObj }),
                  alt_text: this.state.upload.alt_text,
                }
              : completionObj,
          );
        },
        error: (errorMessage) => {
          this.setState({
            upload: {
              status: 'error',
              error: errorMessage,
              progress: 0,
            },
          });
        },
      },
      {
        documentsUrlPrefix,
        policyUrlPrefix,
      },
    );
  },

  handleAltTextChange(update) {
    const {
      update: { alt_text },
    } = update;
    const { id, url } = this.state.upload;
    this.props.updateField({
      id,
      url,
      alt_text,
    });
    this.setState((prevState) => ({
      upload: {
        ...prevState.upload,
        alt_text,
      },
    }));
  },

  render() {
    const { schema, fieldId } = this.props;

    return (
      <FormFieldUpload
        altTextLabel={schema.altTextLabel}
        buttonSize={schema.buttonSize}
        className={schema.className}
        fieldId={fieldId}
        handleAltTextChange={this.handleAltTextChange}
        handleFileUpload={this.handleFileUpload}
        handleRemoveUpload={this.handleRemoveUpload}
        hasAltTextInput={schema.hasAltTextInput}
        hasIcon={schema.hasIcon}
        hasRemoveUploadButton={schema.hasRemoveUploadButton}
        hasReplaceUploadButton={schema.hasReplaceUploadButton}
        icon={schema.icon}
        iconPosition={schema.iconPosition}
        isDisabled={schema.isDisabled}
        permittedFormats={schema.permittedFormats}
        removeUploadButtonText={schema.removeUploadButtonText}
        replaceUploadButtonText={schema.replaceUploadButtonText}
        upload={this.state.upload}
        uploadType={schema.uploadType}
        uploadButtonText={schema.uploadButtonText}
      />
    );
  },
});

registerField('Upload', React.memo(FormFieldUploadContainer));

export default FormFieldUploadContainer;
